module.exports = __webpack_public_path__ + "theme/fonts/element-icons.woff";


//////////////////
// WEBPACK FOOTER
// ./node_modules/element-ui/lib/theme-chalk/fonts/element-icons.woff
// module id = 307
// module chunks = 1